import React from 'react'

import {
    PriceTypeBoxDiv,
    PricingTypeBoxContentsDiv,
    PriceTypeTierDiv,
    PriceTypeCostDiv,
    PriceTypePerksDiv,
    PriceTypeTierText,
    PriceTypeCostText,
    PerkList,
    PerkListItem
} from '../../Styles/Components/PricingTypeBoxStyles.js'

function PricingTypeBox(props){
    let ptTier = props.ptTier
    let ptCost = props.ptCost
    let ptPerks = props.ptPerks

    return (
        <PriceTypeBoxDiv>
            <PricingTypeBoxContentsDiv>
                <PriceTypeTierDiv>
                    <PriceTypeTierText>{ptTier}</PriceTypeTierText>
                </PriceTypeTierDiv>
                <PriceTypeCostDiv>
                    <PriceTypeCostText>{ptCost}</PriceTypeCostText>
                </PriceTypeCostDiv>
                <PriceTypePerksDiv>
                    <PerkList>
                        {ptPerks.map(item => (
                            <PerkListItem key={item}>{item}</PerkListItem>
                        ))}
                    </PerkList>
                </PriceTypePerksDiv>
            </PricingTypeBoxContentsDiv>
        </PriceTypeBoxDiv>
    )
}

export default PricingTypeBox